import React from 'react'
import Box from '@mui/material/Box';
import {CircularProgress,LinearProgress } from '@mui/material';

const Loader = () => {
    return (
        // <CircularProgress />
        <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    )
}

export default Loader
